import { ReactNode } from "react";

type Props = {
  value: number | string | ReactNode;
  label: string | ReactNode;
  titleClassName?: string;
  subTitleClassName?: string;
};

const SubInfo = ({
  value,
  label,
  titleClassName,
  subTitleClassName,
}: Props) => {
  return (
    <div className="flex items-center gap-2 item-data-holder">
      <span className={`item-data__title ${titleClassName}`}>{value}</span>
      <sub
        className={`item-data__subTitle text-[#9999A7] mx-[2px] ${subTitleClassName}`}
      >
        {label}
      </sub>
    </div>
  );
};

export default SubInfo;
